<!-- 最小流量分析详情 -->
<template>
  <j-modal
    :title="title"
    width="45%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '400px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('异常/连接异常')" prop="exception">
                <a-input v-model="model.exception" :placeholder="$t('请输入异常/连接异常')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('KL值')" prop="klValue">
                <a-input-number v-model="model.klValue" :placeholder="$t('请输入KL值')" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('区间')" prop="range">
                <a-input v-model="model.range" :placeholder="$t('请输入区间')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('颜色')" prop="color">
                <el-color-picker v-model="model.color" size="small"></el-color-picker>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('建议意见')" prop="suggestion">
                <a-textarea v-model="model.suggestion" :placeholder="$t('请输入建议意见')"></a-textarea>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
            
<script>
import { httpAction, getAction, postAction } from '@/api/manage'
export default {
  name: 'model1',
  components: {},
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      url: {
        getCount: '/jeecg-charge/meterInspectionRecord/getCount',
      },
    }
  },
  methods: {
    add() {
      this.edit({})
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
  },
}
</script>
          <style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
</style>